import { validateUUID } from 'utils/is-uuid'
import { useSetRecoilState } from 'recoil'
import { addAlertQuery, AlertType } from 'services/alert'

import './idpaste.style.css'

export interface Props {
  onChange: (value: string[]) => void
  value: string[]
}

export const IDPaste = (props: Props) => {
  const setAlert = useSetRecoilState(addAlertQuery)

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const strings = e.target.value
      .split('\n')
      .map((value) => value.trim())
      .filter((el) => el !== '')

    for (const str of strings) {
      if (!validateUUID(str)) {
        setAlert([{ message: `container id не распознан`, type: AlertType.ERROR }])
        props?.onChange([])

        return
      }
    }

    props?.onChange(strings)
  }

  return (
    <textarea
      value={props?.value}
      placeholder="Вставьте ID контейнеров"
      autoComplete="false"
      rows={7}
      onChange={handleChange}
    />
  )
}
